import React, { useEffect } from 'react';
import { lightClass } from './theme.css';
import { isFunction } from '~/utils';
function addFonts() {
    const FONTS_ID = 'vulcan-fonts';
    if (document.getElementById(FONTS_ID))
        return;
    const link = document.createElement('link');
    link.href =
        'https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;600;700;900&family=Nunito:wght@300;400;600;700;900&family=Roboto+Mono:wght@300;400;600;700&display=swap';
    link.rel = 'stylesheet';
    link.id = FONTS_ID;
    document.head.appendChild(link);
    return () => {
        const fonts = document.getElementById(FONTS_ID);
        if (fonts)
            fonts.remove();
    };
}
function overrideProperties(theme, root = document.documentElement) {
    Object.entries(theme).forEach(([key, value]) => root.style.setProperty(key, value));
    return () => {
        Object.entries(theme).forEach(([key]) => root.style.removeProperty(key));
    };
}
function VulcanUIThemeProvider(props) {
    const { theme, children, injectFonts = true, root = document.documentElement } = props;
    useEffect(() => {
        if (!theme)
            return;
        return overrideProperties(theme, root);
    }, [theme, root]);
    useEffect(() => {
        if (!injectFonts)
            return;
        return addFonts();
    }, [injectFonts]);
    useEffect(() => {
        if (!root || isFunction(children))
            return;
        root.classList.add(lightClass);
        return () => root === null || root === void 0 ? void 0 : root.classList.remove(lightClass);
    }, [root, children]);
    return React.createElement(React.Fragment, null, children);
}
export default VulcanUIThemeProvider;
//# sourceMappingURL=theme-provider.js.map